<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout row wrap justify-center>
          <!-- MODULE PHOTO GIFT ADMIN SECTION -->
          <v-flex
            class="py-0 pb-1 pt-0 px-1"
            xs12
            v-if="
              ($store.state.storeClient.client.modules.moduleGiftCard.active &&
                $store.state.storeAuth.userProfile.isSuperAdmin &&
                $store.state.storeAuth.userProfile.client ==
                  $store.state.storeClient.client.basicSettings.name) ||
              $store.state.storeAuth.userProfile.isSuperStoreAdmin
            "
          >
            <v-card
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray'
                  : 'border-bottom: 1px solid lightgray'
              "
            >
              <v-card-title
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: #505050'
                    : 'background-color: white; border-bottom: 1px solid lightgray'
                "
                :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
                class="title font-weight-regular"
              >
                <v-icon
                  :class="
                    getTheme() == 'dark' ? 'white--text' : 'primary--text'
                  "
                  class="mr-3"
                  medium
                  >mdi-glass-mug</v-icon
                >
                {{ $t("settingsSubMenuModuleGiftCardTitle") }}
              </v-card-title>
              <v-card-actions
                class="d-flex flex-wrap align-stretch"
                :class="
                  getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: whitesmoke'
                    : 'background-color: white'
                "
              >
                <!-- GIFT CARD DATABASE -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeClient.client.modules.moduleGiftCard
                      .active &&
                      $store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                    $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  path="/settingsGiftCardActive"
                  icon="mdi-wallet-giftcard"
                  :title="$t('dashboardCardSuperAdminGiftCardActive')"
                ></home-menu-admin-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenu' })"
          ></simple-navigation-button>
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import HomeMenuAdminBtn from "@/components/HomeMenuAdminBtn";
import { G_MODULE_GIFT_CARD } from "@/constants";

export default {
  name: "settingsSubMenuModuleGiftCard",
  components: {
    AppNavigation,
    SimpleNavigationButton,
    HomeMenuAdminBtn,
  },
  created() {
    this.G_MODULE_GIFT_CARD = G_MODULE_GIFT_CARD;
  },
};
</script>
<style scoped>
.item {
  margin: 5px;
  padding: 5px;
  width: 100px;
  text-align: center;
}
</style>
